import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'
import { templateMap, TemplateTypes } from '../theme/assets/template'

interface ConfigData {
  template: TemplateTypes
  setTemplate: Dispatch<SetStateAction<TemplateTypes>>
}

const initialValue: ConfigData = { template: TemplateTypes.TEMPLATE_1, setTemplate: () => {} }

export const ConfigContext = createContext(initialValue)

export const ConfigProvider = ({ children }: { children: ReactNode | Array<ReactNode> }) => {
  const [template, setTemplate] = useState(TemplateTypes.TEMPLATE_1)
  return <ConfigContext.Provider value={{ template, setTemplate }}>{children}</ConfigContext.Provider>
}

export const useTemplate = () => {
  const curConfig = useContext(ConfigContext)
  return templateMap.get(curConfig.template)
}
